import React from 'react'

export function UiWalletZeroState(props) {
    

    return (
        <> 
        <div className='sb-walletcard-zero-state'>
            <h4>Your Wallet is currently empty</h4>
        </div>
        </>
    )
}
